import { render, staticRenderFns } from "./DialogBit.vue?vue&type=template&id=c34565b6&"
import script from "./DialogBit.vue?vue&type=script&lang=js&"
export * from "./DialogBit.vue?vue&type=script&lang=js&"
import style0 from "./DialogBit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports